module.exports = __webpack_public_path__ + "static/media/display23.6c0b8e8b.jpg";